<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <article class="media">
    <figure class="media-left">
      <div class="image is-64x64">
        <img
          v-if="item.images && item.images.length >= 0"
          @error="onImageError"
          loading="lazy"
          class="image-preview"
          :src="imageUrl"
        />
      </div>
    </figure>
    <div class="media-content">
      <div class="content">
        <p>
          <span class="plant-name" v-if="item.name">
            <text-highlight
              :queries="[search]"
              :caseSensitive="false"
              :diacriticsSensitive="false"
              >{{ item.name }}</text-highlight
            >
          </span>
          <small class="latin" :class="{ 'plant-latin-name': !!item.name }">
            <text-highlight
              :queries="[search]"
              :caseSensitive="false"
              :diacriticsSensitive="false"
              >{{ item.name_lat }}
            </text-highlight>
          </small>
          <br />
          <template v-if="item.family">
            Čeleď:
            <span v-if="item.family.name">
              {{ item.family.name }}
              (<span class="plant-family-latin-name latin">
                {{ item.family.name_lat }}</span
              >)
            </span>
            <span v-if="!item.family.name">
              <span class="plant-family-latin-name latin">
                {{ item.family.name_lat }}</span
              >
            </span>
          </template>
        </p>
      </div>
      <nav class="info is-flex">
        <div class="info-item" v-if="item.content_length > 120">
          <span
            class="tag is-link"
            :title="$t('This plant contains textual description')"
          >
            {{ $t("Contains text") }}</span
          >
        </div>
        <div v-if="item.tags && item.tags.length > 0">
          <div
            class="info-item"
            :key="`tag_${tagIdx}`"
            v-for="(tag, tagIdx) in item.tags"
          >
            <span
              class="tag is-info is-success"
              v-if="tag.id === 185"
              :title="$t('This plant is bearing fruits right now')"
            >
              {{ $t("Bearing fruits") }}</span
            >
            <span
              class="tag is-info is-success"
              v-if="tag.id === 11"
              :title="$t('This plant is blooming right now')"
            >
              {{ $t("Blooming") }}</span
            >
          </div>
        </div>
        <div class="flex-spacer"></div>
        <div class="show-on-map-button">
          <router-link
            :to="{ name: ROUTE_NAMES.GARDEN_MAP, query: { plant: item.id } }"
          >
            <button class="button is-small">Show on map</button>
          </router-link>
        </div>
      </nav>
    </div>
  </article>
</template>
<script>
import TextHighlight from "vue-text-highlight";
import { ROUTE_NAMES } from "@/routes";

export default {
  data() {
    return {
      imgIdx: 0,
      imgStaticDomain: true
    };
  },
  components: {
    TextHighlight
  },
  computed: {
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    },
    imageUrl() {
      if (this.imgIdx >= this.item.images.length) {
        return "/img/logo_simple.svg";
      }
      if (this.imgStaticDomain) {
        return `https://static.bz-uk.roamingowl.com/images/250/${
          this.item.images[this.imgIdx].id
        }.${this.webp ? "webp" : "png"}`;
      }
      return this.item.images[this.imgIdx].url;
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    search: {
      type: String
    },
    webp: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onImageError() {
      if (this.imgStaticDomain) {
        this.imgStaticDomain = false;
        return;
      }
      if (this.imgIdx >= this.item.images.length) {
        return;
      }

      this.imgIdx++;
      this.imgStaticDomain = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../../../styles/index";

.image-preview {
  width: 64px !important;
  height: 64px !important;
  object-fit: cover;
}

.plant-name {
  font-weight: bold;
}

.plant-latin-name {
  margin-left: 0.5rem;
}

.info {
  flex-wrap: wrap;
}

.info-item {
  margin: 0 0.75rem 0.75rem 0;
}

.show-on-map-button {
  @include mobile {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

.latin {
  font-style: italic;
  color: #646464;
}
</style>
